module.exports = __webpack_public_path__ + "assets/img/3_1401_big.9761f450.jpg";